import request from '../utils/request';

/**
 * 获取系统错误日志列表
 * @param {Object} params 查询参数
 * @param {number} params.page 页码，默认1
 * @param {number} params.pageSize 每页数量，默认10
 * @param {Object} params.queryDTO 查询条件
 * @returns {Promise} 请求结果
 */
export const getSystemErrorLogList = (params) => {
  return request({
    url: '/system-error-log/list',
    method: 'get',
    params
  });
};


